import {ICustomScope} from "@common/crSelector/directives/paginated-subj-list/paginated-subj-list.directive";
import {IAppRootScopeService} from "@app/app.definition";
import angular from "angular";
import {BroadcastService} from "@common/service/broadcast.service";
import {CacheService} from "@common/service/cache.service";
import {Util} from "@common/util";

export interface IEcvPerson {
    init();
}

export class EcvPerson implements IEcvPerson {
    static $inject = ["$scope", "$rootScope", "$interpolate", "$timeout", "BroadcastService", "CacheService"];
    allTeams: any;
    selectedValue: any;
    selectedChange: any;
    textChange: any;
    clickOnNotFound: any;
    selectedItem: any;
    teamLimit: any;
    addNewMsg: any;
    fieldDisabled: boolean;
    teamPlaceholder: string;
    searchText: any;
    displayAs: string;
    formName: string;
    parentForm: any;
    tempItem: any;
    isFocused: boolean = false;
    loadFirstTime: boolean = true;
    addBtnPosition: any;
    selectAllBtnPosition: any;
    mugshotConfig: any;
    clickedOnBtn: boolean = false;
    multipleSelectedValue: any;
    multiple: any;
    mugshotBelow: any;
    sendingSelectedTeam: any;
    isEdgeIE: boolean = (isIE11 || window.navigator.userAgent.indexOf("Edge") > -1);
    isEdge: boolean = window.navigator.userAgent.indexOf("Edge") > -1;
    tempSearchText: any;
    isAllSelected: boolean;
    disableSelectOpt: boolean;
    fieldName;
    mgshtTooltipClass;
    canUsrCreateTeam;
    isRequired = true;

    constructor(
        private $scope: ICustomScope,
        private $rootScope : IAppRootScopeService,
        $interpolate,
        private $timeout: ng.ITimeoutService,
        BroadcastService : BroadcastService,
        private $_cache : CacheService
    ) {
        var personVm: any = this;

        $scope.$watch('personVm.selectedValue', function (newV, oldV) {
            if (!personVm.multiple && !!personVm.allTeams && personVm.displayAs != 'global-cr') {
                var item = null;
                if (typeof (personVm.selectedValue) === 'number') {
                    item = personVm.allTeams.find(x => x.subjectId == personVm.selectedValue);
                } else {
                    item = personVm.allTeams.find(x => x.subjectId == personVm.selectedValue.subjectId);

                }
                if (!!item) {
                    personVm.selectedItem = item;
                }
            } else {
                personVm.init(false);
            }
        })

        BroadcastService.registerCallBack('new-created-item', $scope.$id, () => {
            this.searchText = '';
        });
        $scope.$on('$destroy', function () {
            BroadcastService.removeCallBack('new-created-item', $scope.$id);
            personVm.allTeams.forEach((x) => {
                x.selected = false;
            })
        })
    }

    init = (readOnly = true) => {
        var personVm: any = this;
        personVm.canUsrCreateTeam = this.$_cache.get('isCreateTeamAllow', true);
        var config = {
            tooltip: 'right',
            size: 'xs',
            hideStatus: true,
            forceUpdate: true
        }
        !!this.multiple && !this.multipleSelectedValue && (this.multipleSelectedValue = [])
        if (!!this.allTeams && this.sendingSelectedTeam == "false") {
            var item = this.allTeams.find(x => x.subjectId == this.selectedValue);
            if (!!item) {
                this.selectedItem = item;
            }
            config.tooltip = 'top';
            config.size = 'small';
            config.hideStatus = false;
            config.forceUpdate = false;
        } else if (!!this.allTeams && this.sendingSelectedTeam == "true" && !this.multiple && !this.mugshotBelow) {
            this.selectedItem = this.selectedValue;
        } else if (!!this.allTeams && this.sendingSelectedTeam == "true" && !!this.multiple) {
            !this.multipleSelectedValue && (this.multipleSelectedValue = [])
            var multiTeams = this.multipleSelectedValue.map(function (x) {
                return x.subjectId;
            })
            this.allTeams.forEach(function (x) {
                if (multiTeams.includes(x.subjectId)) {
                    x.selected = true;
                }
            })
            if (this.allTeams.length == this.multipleSelectedValue.length) {
                this.isAllSelected = true;
                this.changeSelAllBtn();
            }
        }
        this.mugshotConfig = config;
        this.parentForm = this.$scope.$parent[this.formName];
        if (this.isEdgeIE) {
            this.$timeout(function () {
                var el;
                if (personVm.displayAs == 'global-cr') {
                    el = angular.element(".global-cr-height md-autocomplete input");
                    el.scope().$mdAutocompleteCtrl.isReadonly = true;
                } else {
                    el = angular.element(".team-member-directive md-autocomplete input");
                }
                var focus = function (event) {
                    setTimeout(function () {
                        document.body.focus();
                        window.removeEventListener('focus', focus);
                    }, 10);
                }
                window.addEventListener('focusout', function (event) {
                    if (el.is(':focus')) {
                        window.addEventListener('focus', focus);
                    }
                });
            }, 0);
        }
        $(window).on('scroll', function () {
            angular.element("#glbl-cr-drpdwn input").blur();
        });
    }

    getClasses = () => {
        let classes = [];
        if (!!this.selectedItem && !this.mugshotBelow) {
            classes.push('input-filled')
        }
        if (this.displayAs == 'analytics-field-cr') {
            classes.push('analytics-input')
        }
        if (this.displayAs == 'assign-service-cr' || this.displayAs == 'manage-cr' || this.displayAs == 'analytics-field-multiple-cr') {
            classes.push('padding-left-0')
        }
        if (!!this.parentForm && this.parentForm.invalid && !this.selectedValue && this.multipleSelectedValue.length <= 0) {
            classes.push('error-bottom-line')
        }
        if (!!this.isFocused) {
            classes.push('border-radius-on-open')
        }
        if (!!this.selectedItem && (this.selectedItem.isFormerTeamMember || this.selectedItem.isFrozen)) {
            classes.push('padding-right-55')
        }
        if (isIE11) {
            classes.push('line-height-normal')
        }
        return classes;
    }
    loadMoreTeams = () => {
        this.$timeout(() => {
            this.searchText = " ";
        }, 100);
    }

    querySearch = (query) => {
        var results;
        if (this.displayAs == 'analytics-field-multiple-cr') {
            this.$timeout(() => {
                let drpdwnTop = $('#analytics-field-multiple-cr-' + this.fieldName + '-inpt')[0].getBoundingClientRect();
                $('#sel-all-button-' + this.fieldName).css('top', drpdwnTop.top + window.pageYOffset);
                $('#sel-all-button-' + this.fieldName).css('left', drpdwnTop.left + window.pageXOffset);
                $('#sel-all-button-' + this.fieldName).css('width', drpdwnTop.width);
            }, 100);
        }
        if (!!this.mugshotBelow && !!this.multiple) {
            this.tempSearchText = query;
        }
        if (this.loadFirstTime && !query) {
            this.loadFirstTime = false;
            results = this.allTeams.slice(0, 20);
            this.loadMoreTeams();
        } else if (query == " ") {
            results = this.allTeams;
            this.searchText = "";
        } else if (query) {
            var lowercaseQuery = query.toLowerCase();
            results = this.allTeams.filter(function (team) {
                return (team.fullName.toLowerCase().indexOf(lowercaseQuery) != -1);
            });
        } else {
            results = this.allTeams;
        }
        if (results.length == 0) {
            this.disableSelectOpt = true;
            this.isAllSelected = false;
        } else {
            this.disableSelectOpt = false;
            let deselected = results.find(r => !r.selected);
            if (!deselected) {
                this.isAllSelected = true;
            } else {
                this.isAllSelected = false;
            }
        }
        this.changeSelAllBtn();
        var arr = ["top0", "top40", "top80", "top120", "top160", "top200", "top240"];
        this.selectAllBtnPosition = arr[0];
        if (results.length >= 6) {
            this.addBtnPosition = arr[6];
        } else {
            this.addBtnPosition = arr[results.length];
        }

        return results;
    }

    changeSelAllBtn = () => {
        let selAllBtn = $('#sel-all-button-' + this.fieldName).find('button');

        if (this.isAllSelected) {
            selAllBtn.text('DESELECT ALL');
        } else {
            selAllBtn.text('SELECT ALL');
        }

        if (this.disableSelectOpt) {
            selAllBtn.prop('disabled', true);
        } else {
            selAllBtn.prop('disabled', false);
        }
    }

    selectAll = (event) => {
        var personVm: any = this;
        if (!!event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.disableSelectOpt) {
            this.disableSelectOpt = true;
            this.changeSelAllBtn();

            var lowercaseQuery = !!this.tempSearchText ? this.tempSearchText.toLowerCase() : '';
            var results = this.allTeams.filter(function (team) {
                return (team.fullName.toLowerCase().indexOf(lowercaseQuery) != -1);
            });
            //De-select all the options
            if (!!this.isAllSelected) {
                for (let team of results) {
                    team.selected = false;
                    this.multipleSelectedValue = this.multipleSelectedValue.filter((recipient) => {
                        return recipient.subjectId != team.subjectId;
                    });
                }
            } else {    //Select all options
                for (let team of results) {
                    if (!team.selected) {
                        this.multipleSelectedValue.push(team);
                        team.selected = true;
                    }
                }
            }
            this.isAllSelected = !this.isAllSelected;
            this.$timeout(() => {
                personVm.selectedChange();
                personVm.disableSelectOpt = false;
                personVm.changeSelAllBtn();
                personVm.$timeout(() => {
                    let drpdwnTop = $('#analytics-field-multiple-cr-' + personVm.fieldName + '-inpt')[0].getBoundingClientRect();
                    $('.sel-all-button').css('left', drpdwnTop.left + window.pageXOffset);
                }, 10);
            }, 500);
        }
    }

    selectedItemChange = (team, $event) => {
        var personVm: any = this;
        if (!!team && !!team.subjectId) {
            if (!!this.mugshotBelow && !!this.multiple) {
                this.searchText = this.tempSearchText;
            }
            if (!this.selectedValue || team.subjectId != this.selectedValue.subjectId) {
                if (this.displayAs == 'global-cr') {
                    angular.element(".global-cr-height md-autocomplete input").blur();
                } else {
                    this.tempItem = team;
                    if (!!this.mugshotBelow && !this.multiple) {
                        this.selectedValue = team;
                        (document.querySelector(".team-member-directive md-autocomplete input") as HTMLInputElement).value = "";
                    } else if (!!this.mugshotBelow && !!this.multiple) {
                        if (!!team.selected) {
                            let subId;
                            if (!!team.person) {
                                subId = team.person.subjectId;
                                team.person.selected = false;
                            } else {
                                subId = team.subjectId;
                                team.selected = false;
                            }
                            this.isAllSelected = false;
                            this.changeSelAllBtn();

                            this.multipleSelectedValue = this.multipleSelectedValue.filter((recipient) => {
                                return recipient.subjectId != subId;
                            });
                        } else {
                            this.multipleSelectedValue.push(team);
                            team.selected = true;
                            var lowercaseQuery = this.tempSearchText.toLowerCase();
                            var results = this.allTeams.filter(function (team) {
                                return (team.fullName.toLowerCase().indexOf(lowercaseQuery) != -1);
                            });
                            if (results.length == this.multipleSelectedValue.length) {
                                this.isAllSelected = true;
                                this.changeSelAllBtn();
                            }
                        }
                        this.selectedItem = undefined;
                    } else {
                        this.selectedValue = (this.displayAs == 'analytics-field-cr') ? team : team.subjectId;
                        if (this.isEdge) {
                            angular.element(".team-member-directive md-autocomplete input").select();
                            if (window.getSelection) {
                                window.getSelection().removeAllRanges();
                            }
                        }
                        angular.element(".team-member-directive md-autocomplete input").blur();
                    }

                }
                if (!this.multiple || this.displayAs == 'analytics-field-multiple-cr') {
                    (this.displayAs != 'analytics-field-multiple-cr') && this.inputBlurred();
                    this.$timeout(function () {
                        personVm.selectedChange({selectedItem: team});
                    }, 0);
                }
            } else if ((!!this.selectedValue || team.subjectId == this.selectedValue.subjectId) && this.displayAs == 'global-cr') {
                angular.element(".global-cr-height md-autocomplete input").blur();
                this.inputBlurred();
            }
        } else {
            return;
        }
    }

    keyUp = (str, customItem, select) => {
        var component = angular.element(".md-autocomplete-suggestions-container li > md-autocomplete-parent-scope > .highlightSelected")
        if (!!component[0]) {
            component[0].classList.remove("highlightSelected")
        }
        if (this.addNewMsg != null && this.canUsrCreateTeam) {
            if (str.keyCode == 13 && (!!this.tempItem || !!this.selectedItem) && !this.multiple) {
                angular.element(".team-member-directive md-autocomplete input").blur();
            }
            this.textChange({str: str, customItem: customItem, select: select});
        }
    }

    addOnNotfound = (event, customItem, addbtn) => {

        event.preventDefault();
        if (!!this.tempItem || !!this.selectedItem) {
            angular.element(".team-member-directive md-autocomplete input").blur();
        }
        if (!!addbtn) {
            this.clickedOnBtn = true;
        }
        var personVm: any = this;
        this.clickOnNotFound({customItem: customItem});
        this.$timeout(function () {
            personVm.clickedOnBtn = false;
        }, 1000)
    }

    searchTextChange = () => {
        // this.selectedValue=undefined;
    }

    inputClicked = () => {

        if (!this.isFocused && !this.fieldDisabled) {
            this.isFocused = true;
            if (this.displayAs == 'analytics-field-multiple-cr') {
                var elemDiv = $('.sel-all-button');
                var cln = elemDiv[0].cloneNode(true);
                document.body.appendChild(cln);
                $(cln).attr('id', 'sel-all-button-' + this.fieldName);
                this.changeSelAllBtn();
                $(cln).removeClass('ng-hide');
                //Click handler for select/deselect option
                $(cln).off('mousedown').on('mousedown', (event) => {
                    this.selectAll(event);
                })
            }
            if (this.isEdgeIE && this.displayAs == 'global-cr') {
                var el = angular.element(".global-cr-height md-autocomplete input");
                (el.scope() as any).$mdAutocompleteCtrl.isReadonly = false;
                var personVm: any = this;
                this.$timeout(function () {
                    if (personVm.searchText == '') {
                        el.select().focus();
                    }
                }, 0)
            }
            if (!!this.selectedItem) {
                this.tempItem = this.selectedItem;
                this.searchText = '';
            }
        }
    }

    openDropdown = () => {
        if (this.displayAs != 'global-cr') {
            angular.element(".team-member-directive md-autocomplete input").focus();
        } else {
            angular.element(".global-cr-height md-autocomplete input").focus();
        }
        this.inputClicked();
    }

    inputBlurred = () => {

        var personVm: any = this;

        if (!!personVm.isFocused) {
            personVm.isFocused = false;
            if (this.displayAs == 'analytics-field-multiple-cr') {
                var elemDiv = $('#sel-all-button-' + this.fieldName);
                document.body.removeChild(elemDiv[0]);

            }
            if (this.isEdgeIE && this.displayAs == 'global-cr') {
                var el = angular.element(".global-cr-height md-autocomplete input");
                (el.scope() as any).$mdAutocompleteCtrl.isReadonly = true;
            }
            if (personVm.displayAs == 'global-cr' && personVm.selectedValue == null) {
                angular.element(".global-cr-height md-autocomplete input").blur();
            }
            if (personVm.displayAs == 'analytics-field-multiple-cr') {
                angular.element(".team-member-directive md-autocomplete input").blur();
            }
            //Cancel self-assign form action
            if (personVm.displayAs == 'global-cr' && personVm.selectedItem == null && !!personVm.$rootScope.qckAssgnFrm) {
                personVm.$rootScope.qckAssgnFrm = null;
                this.$timeout(function () {
                    //WEB-11790 : If user has clicked the self assign button again then do not show cancel toastr.
                    if (!personVm.$rootScope.qckAssgnFrm)
                        toastr.success(Util.CANCEL_SELF_ASSIGN_FORM);
                }, 500);
            }

            if (!!personVm.tempItem && personVm.displayAs != 'global-cr' && !personVm.mugshotBelow) {
                personVm.setPreviousItem(personVm.tempItem);
            } else if (personVm.displayAs == 'global-cr' && !personVm.clickedOnBtn) {
                personVm.setPreviousItem(personVm.selectedValue)
            }
        }
        if (!!this.mugshotBelow || (this.displayAs == 'assign-form-cr' && !this.selectedItem)) {
            this.searchText = '';
        } else if (this.selectedValue == undefined && this.displayAs == 'global-cr') {
            this.searchText = '';
            (document.querySelector(".global-cr-height md-autocomplete input") as HTMLInputElement ).value = ""
        }
    }

    setPreviousItem = (team) => {
        this.selectedItem = team;
        this.tempItem = undefined;
    }
}

function ecvPerson(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/crSelector/directives/subj-list/person.directive.html',
        replace: true,
        scope: true,
        controller: EcvPerson,
        controllerAs: 'personVm',
        bindToController: {
            'allTeams': '=config',
            'selectedChange': '&',
            'textChange': '&',
            'clickOnNotFound': '&',
            'selectedValue': '=',
            'multipleSelectedValue': '=',
            'teamLimit': '=?limit',
            'fieldDisabled': '=?disable',
            'displayAs': '@displayAs',
            'teamPlaceholder': '@teamPlaceholder',
            'formName': '@formName',
            'label': '@label',
            'addNewMsg': '@',
            'multiple': '@',
            'mugshotBelow': '@mugshotBelowInput',
            'sendingSelectedTeam': '@',
            'fieldName': '@',
            'mgshtTooltipClass': '@',
            'formSubmitted': '=',
            "isRequired": '=?'
        },
        link: (scope: ICustomScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPerson): void => {
            controller.init();
            scope.$on("$destroy", function () {
                scope.element = null;
            });
            scope.element = element;
        }
    }
}

angular.module('eCareVault.common.crSelector').directive('ecvPerson', ecvPerson);
